import { render } from "./close.vue?vue&type=template&id=4389d230&ts=true"
import script from "./close.ts?vue&type=script&lang=ts&external"
export * from "./close.ts?vue&type=script&lang=ts&external"

import "./close.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__